module.exports = __webpack_public_path__ + "static/media/zolturd-eye-zap.f670d06e.mp4";